import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
const SortedSkuCategoryNames = ['MARKETING_PRODUCTS', 'SALES_PRODUCTS', 'SERVICE_HUB_PRODUCTS', 'CMS_HUB_PRODUCTS', 'OPERATIONS_HUB_PRODUCTS', 'COMMERCE_PRODUCTS'];
export const sortSkuCategoryNames = skuCategoryNames => {
  const copy = [...skuCategoryNames];
  copy.sort((a, b) => {
    return SortedSkuCategoryNames.indexOf(a) - SortedSkuCategoryNames.indexOf(b);
  });
  return copy;
};
const SortedProductLevels = ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
export const sortApiNamesByProductLevel = apiNames => {
  const copy = [...apiNames];
  copy.sort((a, b) => {
    return SortedProductLevels.indexOf(getProductLevelFromApiNameString(a)) - SortedProductLevels.indexOf(getProductLevelFromApiNameString(b));
  });
  return copy;
};